
export default {
  name: 'ViewDetails',
  props: {
    imgList: {
      type: Array,
      default: () => {}
    },
    imgLists: {
      type: [Array, Object],
      default: () => {}
    },
    address: {
      // 传入图片或者视频地址
      type: String,
      default: ''
    },
    picUrlind: {
      // 传入图片下标
      type: [String, Number],
      default: 0
    },
    picDataind: {
      // 传入数据下标
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      autoplay: true,
      isMp4: true,
      isShow: false // 是否弹出来
    }
  },
  mounted() {
    if (!this.address || !this.imgList) {
      return
    }
    if (this.address.includes('.mp4')) {
      this.isMp4 = true
    } else {
      this.isMp4 = false
    }
    document.addEventListener('click', this.close, { passive: true })
  },
  beforeDestroy() {
    document.addEventListener('click', this.close, { passive: true })
  },
  methods: {
    close(e) {
      // 点击非组件区域关闭下拉框
      if (e.target.className == 'container-john') {
        this.isShow = false
      }
    },
    closeView() {
      this.isShow = false
    },
    open() {
      this.isShow = true
    }
  }
}
